import { createMuiTheme } from '@material-ui/core';

import { appConfig } from '../../../../../../../config/customization';
import { accountSelectorSize, mobileDefaultPaddingLeft } from '../../../../../../../constants/sizes';
import Device from '../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    flexShrink: 0
  },
  accounts: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [Device.mobile]: {
      padding: `25px ${mobileDefaultPaddingLeft}px`
    }
  },

  accountsSelector: {
    minWidth: accountSelectorSize,
    border: `1px solid ${appConfig.colors.bordersGray}`,
    borderRadius: 5,
    display: 'flex',
    width: '60%',
    [Device.mobile]: {
      width: `calc(100% - ${mobileDefaultPaddingLeft * 2}px)`,
      margin: `0px ${mobileDefaultPaddingLeft}px`
    }
  },
  selectPopUp: {
    width: '100%',
    justifyContent: 'space-between'
  },
  myAccountsButton: {
    display: 'flex',
    alignItems: 'center'
  }
};

export const theme = createMuiTheme({
  overrides: {
    MuiBadge: {
      colorPrimary: {
        color: appConfig.colors.badgeIcon,
        backgroundColor: appConfig.colors.badgeBase
      },
      badge: {
        width: 20,
        height: 20,
        top: -8,
        right: -8,
        fontWeight: 700,
        fontSize: '0.9rem'
      }
    }
  }
});
